var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8248 10.745C19.8248 10.5398 19.93 10.4869 20.1647 10.4869C20.3691 10.4949 20.5633 10.5785 20.7097 10.7215L21.1494 10.2408C20.9395 10.0178 20.6611 9.87129 20.3584 9.82455V9.32715H19.7725V9.83729C19.5464 9.86594 19.3393 9.97814 19.1918 10.1518C19.0443 10.3255 18.9671 10.5481 18.9754 10.7758C18.9754 11.6372 20.3162 11.6955 20.3162 12.0884C20.3162 12.27 20.2223 12.3518 19.9528 12.3518C19.6896 12.3392 19.4363 12.2474 19.2262 12.0884L18.8394 12.6682C19.1095 12.8726 19.4289 13.0019 19.7651 13.043V13.5236H20.351V13.0021C20.584 12.9703 20.7968 12.8533 20.9484 12.6736C21.1 12.4939 21.1795 12.2643 21.1715 12.0294C21.1782 11.1318 19.8248 11.1204 19.8248 10.745Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2438 6.26855H10.5125C9.94675 6.26855 9.40419 6.49329 9.00416 6.89332C8.60413 7.29335 8.37939 7.83591 8.37939 8.40164V27.5987C8.37939 28.1645 8.60413 28.707 9.00416 29.1071C9.40419 29.5071 9.94675 29.7318 10.5125 29.7318H22.2438C22.8095 29.7318 23.3521 29.5071 23.7521 29.1071C24.1521 28.707 24.3769 28.1645 24.3769 27.5987V8.40164C24.3769 7.83591 24.1521 7.29335 23.7521 6.89332C23.3521 6.49329 22.8095 6.26855 22.2438 6.26855ZM22.7653 27.5579C22.7511 27.6885 22.6908 27.8098 22.5952 27.9C22.4997 27.9902 22.375 28.0433 22.2438 28.0499H10.5125C10.3838 28.0515 10.2587 28.0078 10.159 27.9264C10.0594 27.8451 9.99157 27.7312 9.96748 27.6048V16.7262H22.7653V27.5579ZM22.7653 15.0878H9.96748V8.40164C9.98167 8.27099 10.042 8.14968 10.1376 8.0595C10.2332 7.96931 10.3578 7.91617 10.489 7.9096L10.5125 7.86871H22.2438C22.3827 7.87468 22.5141 7.93354 22.6111 8.03324C22.7081 8.13294 22.7632 8.26594 22.7653 8.40499V15.0878Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 18.4805H11.5669V20.0799H13.7V18.4805Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 21.6797H11.5669V23.2792H13.7V21.6797Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4334 18.4805H15.3003V20.0799H17.4334V18.4805Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4334 21.6797H15.3003V23.2792H17.4334V21.6797Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1775 18.4805H19.0444V20.0799H21.1775V18.4805Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1775 21.6797H19.0444V23.2792H21.1775V21.6797Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 24.8799H11.5669V26.4794H13.7V24.8799Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.178 24.8799H15.3003V26.4794H21.178V24.8799Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.16fb9f360e5f4f68ec7712956249d9ac.svg";
export { ForwardRef as ReactComponent };